import API from "..";

export default class SDSRequestSyntheticIndicator {

  constructor({
    syntheticIndicatorName,
    isActive
  }) 
    
  {
    this.syntheticIndicatorName = syntheticIndicatorName;
    this.isActive = isActive;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/sdsRequestSyntheticIndicator`);
    if (data.result) {
        return data.result.map((d) => new SDSRequestSyntheticIndicator(d));
    }
    else {
        return [];
    }
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/sdsRequestSyntheticIndicator`);
    if (data && data.result && data.result.length >0) {
        return data.result.filter((d) => d.isActive);
    }
    else {
        return [];
    }
  }
}
